import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BSKT_LoaiNganh } from '../../services/loai-nganh/LoaiNganhModels';

interface LoaiNganhState {
    listData: BSKT_LoaiNganh[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedId: number | null;
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: BSKT_LoaiNganh | null;
}

const initialState: LoaiNganhState = {
    listData: [],
    status: 'idle',
    selectedId: null,
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: null
};

const loaiNganhSlice = createSlice({
    name: 'loaiNganh',
    initialState,
    reducers: {
        setList: (state, action: PayloadAction<BSKT_LoaiNganh[]>) => {
            state.listData = action.payload;
        },
        setStatus: (state, action: PayloadAction<LoaiNganhState['status']>) => {
            state.status = action.payload;
        },
        selectLoaiNganh: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        setCreateOrEditModel: (state, action: PayloadAction<BSKT_LoaiNganh | null>) => {
            state.createOrEditModel = action.payload;
        },
        setShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<{ show: boolean; id?: number }>) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        insertSuccess: (state, action: PayloadAction<BSKT_LoaiNganh>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action: PayloadAction<BSKT_LoaiNganh>) => {
            const index = state.listData.findIndex((item) => item.ID_loai_nganh === action.payload.ID_loai_nganh);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((item) => item.ID_loai_nganh !== action.payload);
            state.isShowConfirmDeleteModal = false;
            if (state.selectedId === action.payload) {
                state.selectedId = null;
            }
        },
        resetState: () => initialState
    }
});

export const {
    setList,
    setStatus,
    selectLoaiNganh,
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState
} = loaiNganhSlice.actions;

export const loaiNganhReducer = loaiNganhSlice.reducer;
